"use strict"

ready(() => {
	document.querySelectorAll(".case-studies-features .feature-item").forEach((featureItem, key) => {
		setTimeout(() => featureItem.classList.add("is-active"), key * 650);
	})


	const fixFlexOrphans = () => {
		let elements = document.querySelectorAll(".case-studies .case-study");
		let length = elements.length;
		let n = 3;

		if ( (length % n) === 2 ) {
			elements[length - 1].style.marginLeft = "2%";
			elements[length - 1].style.marginRight = "auto";
		}
	}

	fixFlexOrphans();
	window.addEventListener("resize", () => fixFlexOrphans());
})
